import { useAtom } from "jotai";
import { searchTextAtom } from "../../pages/drones-page/state";

function useSearch(initialValue = '') {
  const [searchText, setSearchText] = useAtom<string>(searchTextAtom);
  let timeout: NodeJS.Timeout;

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>, callback: () => void) =>  {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      setSearchText(() => {
        callback();
        return e.target.value
      });
    }, 1000);
  }

  return {
    searchText,
    handleSearch,
    setSearchText,
  };
}

export default useSearch;
